const carouselItems = [
  {
    title: '2024 年度华语电影盛典',
    desc: '盘点过去一年中最令人印象深刻的华语电影佳作，从文艺片到商业大片，每一部都值得细细品味。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20award%20ceremony%20atmosphere%20with%20warm%20golden%20stage%20lighting%2C%20elegant%20red%20carpet%20aesthetic%2C%20film%20festival%20vibe%2C%20deep%20crimson%20and%20gold%20tones%2C%20luxurious%20cinematic%20composition%2C%20clean%20background&width=1000&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '悬疑剧迷必看清单',
    desc: '从国产经典到海外佳作，精挑细选十部烧脑悬疑作品，让你的每一个夜晚都充满悬念与惊喜。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20film%20atmosphere%20with%20shadowy%20warm%20lighting%2C%20noir%20style%20composition%2C%20vintage%20investigation%20aesthetic%2C%20deep%20amber%20and%20crimson%20tones%2C%20clean%20suspenseful%20visual&width=1000&height=600&seq=carousel-02&orientation=landscape',
    tag: '悬疑专场',
  },
  {
    title: '治愈系影视作品推荐',
    desc: '温暖人心的电影和剧集合集，当你需要放松和治愈时，这些作品会是你最好的陪伴。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20healing%20film%20visual%20with%20soft%20sunlight%20and%20gentle%20golden%20hour%20lighting%2C%20comforting%20cinematic%20atmosphere%2C%20simple%20warm%20neutral%20background%2C%20peaceful%20composition%2C%20heartwarming%20aesthetic&width=1000&height=600&seq=carousel-03&orientation=landscape',
    tag: '治愈推荐',
  },
  {
    title: '科幻电影进化史',
    desc: '从经典科幻到现代视觉奇观，带你回顾科幻电影的发展历程和那些改变影史的里程碑作品。',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20evolution%20visual%20with%20futuristic%20warm%20neon%20glow%2C%20space%20exploration%20atmosphere%2C%20technological%20aesthetic%2C%20deep%20amber%20and%20red%20accents%2C%20cinematic%20composition%2C%20clean%20simple%20background&width=1000&height=600&seq=carousel-04&orientation=landscape',
    tag: '影史回顾',
  },
  {
    title: '暑期亲子观影指南',
    desc: '适合全家一起观看的优质影视作品精选，寓教于乐，让亲子时光更加温馨有趣。',
    img: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20warm%20atmosphere%20with%20cozy%20living%20room%20setting%2C%20soft%20golden%20lighting%2C%20joyful%20cinematic%20vibe%2C%20simple%20warm%20background%2C%20wholesome%20family%20entertainment%20aesthetic&width=1000&height=600&seq=carousel-05&orientation=landscape',
    tag: '亲子时光',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">专题推荐</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">精心策划的影视专题，发现更多好内容</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-accent-500 text-background-50 px-2.5 py-1 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-600 transition-colors mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}